import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTheMask from "vue-the-mask";

createApp(App).use(VueTheMask).use(router).use(store).mount("#app");
